import React, { useEffect, useMemo, useState } from "react";
import DataGrid from "../Components/DataGrid";
import Button from "../Components/Button";

export default function RegistroCondominiConciliatiPage() {
  const [anno, setAnno] = useState(new Date().getFullYear().toString());
  const [rows, setRows] = useState([]);
  const [clienti, setClienti] = useState([]);
  const [clienteSelezionato, setClienteSelezionato] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingClienti, setLoadingClienti] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    caricaClienti();
  }, []);

  async function caricaClienti() {
    try {
      setLoadingClienti(true);
      setError("");

      const token = localStorage.getItem("token");
      if (!token) throw new Error("Token mancante");

      const res = await fetch("https://api.lapegna.xyz/conciliazioni/combo_clienti", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || `Errore HTTP ${res.status}`);
      }

      const data = await res.json();

      const listaClienti = Array.isArray(data)
        ? data
        : data.data || data.recordset || [];

      setClienti(listaClienti);

      if (listaClienti.length > 0) {
        const primoCliente = String(listaClienti[0].ID);
        setClienteSelezionato(primoCliente);
        await caricaDati(anno, primoCliente);
      }
    } catch (err) {
      console.error(err);
      setError(err.message || "Errore nel caricamento clienti");
      setClienti([]);
      setRows([]);
    } finally {
      setLoadingClienti(false);
    }
  }

  async function caricaDati(annoDaCaricare = anno, clienteDaCaricare = clienteSelezionato) {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("token");
      if (!token) throw new Error("Token mancante");

      if (!clienteDaCaricare) {
        setRows([]);
        throw new Error("Seleziona un cliente");
      }

      const payload = {
        Cliente: Number(clienteDaCaricare),
        Anno: String(annoDaCaricare),
      };

      const res = await fetch("https://api.lapegna.xyz/conciliazioni/mesi_riconciliati", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || `Errore HTTP ${res.status}`);
      }

      const data = await res.json();
      setRows(data.data || data.recordset || []);
    } catch (err) {
      console.error(err);
      setError(err.message || "Errore nel caricamento dati");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  const renderMese = (value) =>
    Number(value) > 0 ? (
      <div
        style={{
          backgroundColor: "#16a34a",
          color: "white",
          padding: "4px 6px",
          borderRadius: 6,
          textAlign: "center",
          fontSize: 12,
        }}
      >
        OK
      </div>
    ) : "";

  const columns = useMemo(
    () => [
      { key: "Denominazione", label: "Condominio" },
      { key: "Gennaio", label: "Gen", render: renderMese },
      { key: "Febbraio", label: "Feb", render: renderMese },
      { key: "Marzo", label: "Mar", render: renderMese },
      { key: "Aprile", label: "Apr", render: renderMese },
      { key: "Maggio", label: "Mag", render: renderMese },
      { key: "Giugno", label: "Giu", render: renderMese },
      { key: "Luglio", label: "Lug", render: renderMese },
      { key: "Agosto", label: "Ago", render: renderMese },
      { key: "Settembre", label: "Set", render: renderMese },
      { key: "Ottobre", label: "Ott", render: renderMese },
      { key: "Novembre", label: "Nov", render: renderMese },
      { key: "Dicembre", label: "Dic", render: renderMese },
    ],
    []
  );

  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "end",
          marginBottom: 16,
          flexWrap: "wrap",
        }}
      >
        <div>
          <label style={{ display: "block", marginBottom: 6, fontSize: 13, opacity: 0.8 }}>
            Cliente
          </label>

          <select
            value={clienteSelezionato}
            onChange={(e) => setClienteSelezionato(e.target.value)}
            disabled={loadingClienti || loading}
            style={{
              padding: "8px 10px",
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.15)",
              background: "linear-gradient(180deg, #1f2937, #111827)",
              color: "white",
              minWidth: 280,
            }}
          >
            <option value="">
              {loadingClienti ? "Caricamento clienti..." : "Seleziona cliente"}
            </option>

            {clienti.map((cliente) => (
              <option key={cliente.ID} value={cliente.ID}>
                {cliente.RAGIONE_SOCIALE}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: "block", marginBottom: 6, fontSize: 13, opacity: 0.8 }}>
            Anno
          </label>

          <input
            type="number"
            value={anno}
            onChange={(e) => setAnno(e.target.value)}
            style={{
              padding: "8px 10px",
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.15)",
              background: "linear-gradient(180deg, #1f2937, #111827)",
              color: "white",
              width: 120,
            }}
          />
        </div>

        <Button
          onClick={() => caricaDati(anno, clienteSelezionato)}
          disabled={loading || loadingClienti || !clienteSelezionato}
        >
          {loading ? "Caricamento..." : "Filtra"}
        </Button>
      </div>

      {error && <div style={{ color: "red", marginBottom: 12 }}>{error}</div>}

      <DataGrid
        title={`Registro condomini conciliati - ${anno}`}
        rows={rows}
        columns={columns}
        searchField="Denominazione"
        showColumnToggle={false}
      />
    </div>
  );
}